import { COMMON_DOCUMENTS } from './documents';
export const GB = {
    code: 'GB',
    name: 'United Kingdom',
    profileVersion: 1,
    readiness: 'ready',
    timezone: 'Europe/London',
    weekend: [6, 0],
    firstDayOfWeek: 1,
    currency: { code: 'GBP', displayFractionDigits: 2, roundToWholeUnits: false },
    subdivisions: [
        { code: 'GB-ENG', name: 'England' },
        { code: 'GB-SCT', name: 'Scotland' },
        { code: 'GB-WLS', name: 'Wales' },
        { code: 'GB-NIR', name: 'Northern Ireland' },
    ],
    branchSubdivision: 'none',
    locales: {
        ui: ['en'],
        defaultUi: 'en',
        documentSecondary: null,
        secondaryOnTaxDocuments: 'off',
        secondaryOnClinicalDocuments: 'off',
        formatting: { en: 'en-GB' },
    },
    phone: { callingCode: '44', trunkPrefix: '0', nationalLengths: [10], mobilePattern: '^7\\d{9}$', example: '07700900123' },
    names: { parts: ['first', 'middle', 'last'], labels: { middle: 'Middle name' }, askLocalName: false },
    identity: {
        documents: [
            {
                type: 'gb_nhs',
                labelKey: 'identity.gb_nhs',
                label: 'NHS number',
                pattern: '^\\d{10}$',
                normalise: 'digits',
                checksum: 'nhs_mod11',
                onChecksumFail: 'refuse',
                onPatternFail: 'refuse',
                example: '943 476 5919',
            },
            {
                type: 'gb_chi',
                labelKey: 'identity.gb_chi',
                label: 'CHI number (Scotland)',
                pattern: '^\\d{10}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                example: '0101011234',
            },
            {
                type: 'gb_hc',
                labelKey: 'identity.gb_hc',
                label: 'H&C number (Northern Ireland)',
                pattern: '^\\d{10}$',
                normalise: 'digits',
                checksum: 'none',
                onChecksumFail: 'warn',
                onPatternFail: 'warn',
                example: '3201234567',
            },
            ...COMMON_DOCUMENTS,
        ],
        defaultType: 'gb_nhs',
        autoDetect: false,
        capture: { hospital: 'optional', lab: 'optional', pharmacy: 'hidden' },
        askNationality: false,
        dobCalendars: ['gregory'],
    },
    practitionerRegistries: [
        { code: 'GMC', label: 'GMC number' },
        { code: 'NMC', label: 'NMC PIN' },
        { code: 'GPhC', label: 'GPhC registration' },
    ],
    tax: [
        {
            code: 'uk_vat',
            effectiveFrom: '1973-04-01',
            registration: { labelKey: 'tax.gb_vat', label: 'VAT registration number', pattern: '^GB\\d{9}$', checksum: 'none', onFail: 'warn' },
            companyRegistrationLabelKey: 'tax.gb_company',
            companyRegistrationLabel: 'Company No.',
            standardRatePct: 20,
            serviceDefaultCategory: 'exempt',
            productDefaultCategory: 'standard',
            qr: null,
            citizenRelief: null,
        },
    ],
    eInvoicing: { scheme: null, mandatory: 'no', fromDate: null, appliesTo: [] },
    addOns: [],
    feeSplittingDefault: false,
};
//# sourceMappingURL=gb.js.map